import { PluginEquifaxConsumerCreditReportRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxConsumerCreditReportRequest = (
  constructPost: ConstructPost,
  data: PluginEquifaxConsumerCreditReportRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/equifax-consumer-credit-report-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
